import { useProduct } from '../ProductCard';

export const ProductVendor = () => {
  const product = useProduct();

  if (!product) {
    return (
      <div
        data-testid="product-vendor"
        className="tw-grid-area-[vendor] tw-m-2 tw-animate-pulse tw-w-8/12 tw-rounded-md tw-bg-black-200 tw-h-6"
      ></div>
    );
  }

  return (
    <p
      data-testid="product-vendor"
      className="tw-grid-area-[vendor] tw-text-sm tw-text-black-700"
    >
      {product.vendor}
    </p>
  );
};
